import React, { useState } from "react";
import { FieldProps } from "../InputFieldsController/InputFieldsController.utils";
import CygnusForm from "../CygnusForm/CygnusForm";
import { Button } from "react-bootstrap";

const FIELDS: FieldProps[] = [
  {
    id: "fullName",
    type: "text",
    label: "Full Name",
    value: "",
    placeholder: "Enter your full name",
    example: "John Doe",
    show: true,
    disabled: false,
    width: "300px",
    breakLine: false,
    margins: { top: 10, right: 10, bottom: 10, left: 0 },
    validation: [{ type: "required", message: "Full name is required" }],
  },
  {
    id: "bio",
    type: "textarea",
    label: "Short Bio",
    value: "",
    placeholder: "Tell us about yourself",
    show: true,
    disabled: false,
    width: 400,
    breakLine: true,
    margins: { top: 10, right: 10, bottom: 10, left: 0 },
  },
  {
    id: "password",
    type: "password",
    label: "Password",
    value: "",
    placeholder: "Enter your password",
    show: true,
    width: 300,
    breakLine: false,
    validation: [
      { type: "required", message: "Password is required" },
      {
        type: "regex",
        pattern: "/^(?=.*[A-Z])(?=.*\d).{8,}$/",
        message: "Must be 8+ chars, include capital & number",
      },
    ],
  },
  {
    id: "contact",
    type: "contact",
    label: "Phone Number",
    value: "",
    placeholder: "+1 (555) 123-4567",
    show: true,
    width: 300,
    breakLine: true,
    validation: [
      { type: "required", message: "Phone number is required" },
      {
        type: "regex",
        pattern: "/^\+1\d{10}$/",
        message: "Must be 10 digits in US format",
      },
    ],
  },
  {
    id: "gender",
    type: "radio",
    label: "Male",
    value: false,
    show: true,
    radiogroup: "gender",
    width: 120,
    breakLine: false,
  },
  {
    id: "gender_female",
    type: "radio",
    label: "Female",
    value: false,
    show: true,
    radiogroup: "gender",
    width: 120,
    breakLine: false,
  },
  {
    id: "terms",
    type: "checkbox",
    label: "I agree to terms",
    value: false,
    show: true,
    width: 250,
    validation: [{ type: "required", message: "You must agree" }],
  },
  {
    id: "dob",
    type: "date",
    label: "Date of Birth",
    value: null,
    placeholder: "Select your birth date",
    showTimeSelect: false,
    show: true,
    width: 250,
    validation: [{ type: "required", message: "DOB is required" }],
  },
  {
    id: "appointment",
    type: "date",
    label: "Appointment Time",
    value: null,
    placeholder: "Select date & time",
    showTimeSelect: true,
    show: true,
    width: 300,
  },
  {
    id: "country",
    type: "select",
    label: "Country",
    value: "",
    placeholder: "Choose a country",
    options: [
      { id: "US", label: "United States", value: "US" },
      { id: "CA", label: "Canada", value: "CA" },
      { id: "IN", label: "India", value: "IN" },
    ],
    show: true,
    width: 300,
    breakLine: true,
  },
  {
    id: "resume",
    type: "file",
    label: "Upload Resume",
    placeholder: "Drag and drop your file",
    fileLimit: "single",
    value: null,
    uploading: false,
    show: true,
    width: 400,
    breakLine: true,
    validation: [{ type: "required", message: "Resume is required" }],
  },
  {
    id: "sectionHeader",
    type: "header",
    label: "Your Preferences",
    show: true,
    width: "100%",
    headerSize: "h4",
    breakLine: true,
    value: ""
  },
];

const TestFormPage = () => {
  const [isFormValid, setIsFormValid] = useState<boolean>(false)
  const [testFields, setTestFields] = useState<FieldProps[]>(FIELDS);

  return (
    <>
      <CygnusForm
        formId="form-tester"
        fields={testFields}
        onFieldsChange={setTestFields}
        onValidationChange={setIsFormValid}
      />
      <Button disabled={!isFormValid} onClick={()=>console.log("UPDATED FIELDS: ", testFields)}>Submit</Button>
    </>
  );
};

export default TestFormPage;
